export enum Environment {
  development = "dev",
  acceptance = "acc",
  production = "prod",
}
